// extracted by mini-css-extract-plugin
export var footer = "_qg-0";
export var inherit = "_qg-1";
export var input = "_qg-2";
export var modalContent = "_qg-3";
export var quillEditor = "_qg-4";
export var subtitle = "_qg-5";